import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/24/outline";

/** Регионы с флагом primary — сверху и крупно, остальные — ниже мелким шрифтом. */
function RegionSelect({ value, regions, onChange }) {
  const current = regions.find((item) => item.value === value) || regions[0];
  const primary = regions.filter((item) => item.primary);
  const others = regions.filter((item) => !item.primary);

  const option = (item, small) => (
    <Listbox.Option
      key={item.value}
      value={item.value}
      className={({ active }) =>
        `flex cursor-pointer items-center justify-between gap-3 px-3 ${
          small ? "py-1 text-xs text-gray-500 dark:text-gray-400" : "py-1.5 text-sm font-semibold text-gray-800 dark:text-gray-100"
        } ${active ? "bg-indigo-50 dark:bg-indigo-900/40" : ""}`
      }
    >
      {({ selected }) => (
        <>
          <span className={selected ? "text-indigo-600 dark:text-indigo-300" : ""}>
            {item.label}
          </span>
          {selected ? <CheckIcon className="h-4 w-4 text-indigo-600 dark:text-indigo-300" /> : null}
        </>
      )}
    </Listbox.Option>
  );

  return (
    <Listbox value={current?.value} onChange={onChange}>
      <div className="relative flex shrink-0 border-r border-gray-200 dark:border-gray-600">
        <Listbox.Button
          aria-label="Регион"
          className="flex h-full items-center gap-1.5 rounded-l-2xl py-3 pl-3 pr-2.5 text-sm font-semibold text-gray-700 outline-none dark:text-gray-100 sm:pl-4"
        >
          {current?.label}
          <ChevronDownIcon className="h-4 w-4 text-gray-400" />
        </Listbox.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="opacity-0 -translate-y-1"
          enterTo="opacity-100 translate-y-0"
          leave="transition ease-in duration-75"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute left-0 top-full z-30 mt-2 min-w-[10rem] overflow-hidden rounded-xl border border-gray-200 bg-white py-1 shadow-lg outline-none dark:border-gray-700 dark:bg-[#2a2a2a]">
            {primary.map((item) => option(item, false))}
            {primary.length && others.length ? (
              <div className="mx-3 my-1 border-t border-gray-100 dark:border-gray-700" />
            ) : null}
            {others.map((item) => option(item, true))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
}

export default RegionSelect;
